import React from "react";
import "./pageBody.scss";
export default function PageBody({ children, padding, className = "" }) {
  return (
    <div className={`page-body ${className}`} style={{ padding }}>
      <div className="inner-body" id="inner-body">
        {children}
      </div>
    </div>
  );
}
